import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.sessions.rangeOptions);
  const selectedFilters = useSelector((state) => state.sessions.selectedRangeOption);

  const handleUpdateOptions = (data) => {
    dispatch(actionCreators.updateCustomRange(data));
  };

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      includeFilter={false}
      onSelectChange={handleUpdateOptions}
    />
  );
};

export default CustomDateRanges;
